<div class="h-100 admin container-fluid d-flex flex-column col-10 offset-xl-1">
  <h1 class="fw-bold font-34">Welcome back {{currentUser.firstname}} </h1>
  <h6 class="lightGray2">Vous avez <span class="mediumGray fw-bold">{{ STEP2.length }} tâches</span> en cours</h6>

  <div class="w-100 my-4 d-flex flex-row gap1">


    <mat-form-field appearance="fill">
      <mat-label>Importance</mat-label>
      <mat-select [formControl]="priority" multiple>
        <mat-option (click)="doFilter()" *ngFor="let value of PriorityList" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Langue</mat-label>
      <mat-select [formControl]="language" multiple>
        <mat-option (click)="doFilter()" *ngFor="let value of LanguageList" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Service</mat-label>
      <mat-select [formControl]="services" multiple>
        <mat-option (click)="doFilter()" *ngFor="let value of ServicesList" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>


    <button class="btn btn-lf-primary ms-auto d-flex flex-row align-items-center h-fit-content" (click)="open(content)">
      <mat-icon class="me-2 bg-white text-primary font-18 rounded-circle d-flex align-items-center justify-content-center">
        add
      </mat-icon>
      Create a task
    </button>
  </div>

  <div class="d-flex flex-row w-100 justify-content-between gap1">
    <div class="w-33 d-flex flex-row align-items-center text-uppercase ps-4">
      <div class="round-pin me-2 todo rounded-circle"></div>
      <h2 class="text-center m-0 text-black fw-bold font-22"> To do </h2>
      <span class="ms-2 font-10 lightGray2">{{STEP1.length}} tickets</span>
    </div>

    <div class="w-33 d-flex flex-row align-items-center text-uppercase ps-4">
      <div class="round-pin inprogress me-2 rounded-circle"></div>
      <h2 class="text-center m-0 text-black fw-bold font-22">In progress</h2>
      <span class="ms-2 font-10 lightGray2">{{STEP2.length}} tickets</span>
    </div>

    <div class="w-33 d-flex flex-row align-items-center text-uppercase ps-4">
      <div class="round-pin donetask me-2 rounded-circle"></div>
      <h2 class="text-center m-0 text-black fw-bold font-22">Done</h2>
      <span class="ms-2 font-10 lightGray2">{{STEP3.length}} tickets</span>
    </div>
  </div>

  <div class="d-flex flex-row w-100 justify-content-between gap1 flex-grow-1 px-2">
    <div id="TO_DO" class="w-33 mt-3 p-3 br-8" cdkDropList #Step1="cdkDropList"
         [cdkDropListData]="STEP1" [cdkDropListConnectedTo]="[Step2]"
         (cdkDropListDropped)="drop($event)">
      <div class="bg-white px-3 py-2 mb-3 br-6" *ngFor="let item of STEP1" cdkDrag [cdkDragData]="item">
        <div class="d-flex flex-row mb-2">
          <b class="font-18">{{item.title}}</b>
          <span class="lightGray2 font-12 ms-auto">{{item.created_at | date}}</span>
        </div>

        <div class="lightGray mb-2 font-14">
          <span>{{item.owner.name}}</span>
        </div>

        <p class="mb-4 font-12 description-box overflow-hidden">
          {{item.content}}
        </p>

        <div class="row">
          <div class="col-8">
            <mat-chip-listbox aria-label="Fish selection">
              <mat-chip-option *ngIf="item.service" class="font-10 d-flex justify-content-center">{{item.service}}</mat-chip-option>
              <mat-chip-option *ngIf="item.service" class="font-10 d-flex justify-content-center">{{item.language}}</mat-chip-option>
              <mat-chip-option selected class="font-10 d-flex justify-content-center">{{item.priority}}</mat-chip-option>
            </mat-chip-listbox>
          </div>
          <div class="col-4 text-end">
            <img placement="top"
            ngbTooltip="{{item.user.name}}"
            *ngIf="item.user" class="avatar v-middle" src="{{item.user.avatar}}" />
          </div>
        </div>
      </div>
    </div>

    <div id="IN_PROGRESS" class="w-33 mt-3 p-3 br-8" cdkDropList #Step2="cdkDropList"
         [cdkDropListData]="STEP2" [cdkDropListConnectedTo]="[Step3, Step1]"
         (cdkDropListDropped)="drop($event)">
      <div class="bg-white px-3 pt-2 pb-3 mb-2 br-6" *ngFor="let item of STEP2" cdkDrag [cdkDragData]="item">
        <div class="d-flex flex-row mb-2">
          <b class="font-18">{{item.title}}</b>
          <span class="lightGray2 font-12 ms-auto">{{item.created_at | date}}</span>
        </div>

        <div class="lightGray mb-2 font-14">
          <span>{{item.owner.name}}</span>
        </div>

        <p class="mb-4 font-12 description-box overflow-hidden">
          {{item.content}}
        </p>

        <div class="row">
          <div class="col-8">
            <mat-chip-listbox aria-label="Fish selection">
              <mat-chip-option *ngIf="item.service" class="font-10 d-flex justify-content-center">{{item.service}}</mat-chip-option>
              <mat-chip-option *ngIf="item.service" class="font-10 d-flex justify-content-center">{{item.language}}</mat-chip-option>
              <mat-chip-option selected class="font-10 d-flex justify-content-center">{{item.priority}}</mat-chip-option>
            </mat-chip-listbox>
          </div>
          <div class="col-4 text-end">
            <img placement="top"
            ngbTooltip="{{item.user.name}}"
            *ngIf="item.user" class="avatar v-middle" src="{{item.user.avatar}}" />
          </div>
        </div>
      </div>
    </div>

    <div id="DONE" class="w-33 mt-3 p-3 br-8" cdkDropList #Step3="cdkDropList"
         [cdkDropListData]="STEP3" [cdkDropListConnectedTo]="[Step2, Step1]"
         (cdkDropListDropped)="drop($event)">
      <div class="bg-white px-3 pt-2 pb-3 mb-2 br-6" *ngFor="let item of STEP3" cdkDrag [cdkDragData]="item">
        <div class="d-flex flex-row mb-2">
          <b class="font-18">{{item.title}}</b>
          <span class="lightGray2 font-12 ms-auto">{{item.created_at | date}}</span>
        </div>

        <div class="lightGray mb-2 font-14">
          <span>{{item.owner.name}}</span>
        </div>

        <p class="mb-4 font-12 description-box overflow-hidden">
          {{item.content}}
        </p>

        <div class="row">
          <div class="col-8">
            <mat-chip-listbox aria-label="Fish selection">
              <mat-chip-option *ngIf="item.service" class="font-10 d-flex justify-content-center">{{item.service}}</mat-chip-option>
              <mat-chip-option *ngIf="item.service" class="font-10 d-flex justify-content-center">{{item.language}}</mat-chip-option>
              <mat-chip-option selected class="font-10 d-flex justify-content-center">{{item.priority}}</mat-chip-option>
            </mat-chip-listbox>
          </div>
          <div class="col-4 text-end">
            <img placement="top"
            ngbTooltip="{{item.user.name}}"
            *ngIf="item.user" class="avatar v-middle" src="{{item.user.avatar}}" />
          </div>
        </div>
      </div>
    </div>

  </div>


</div>



<!-- MODAL -->
<ng-template #content let-c="close" let-d="dismiss" >
  <div class="modal-container">
    <div class="modal-header">
      <h4 *ngIf="currentUserAdminId" class="modal-title" id="modal-basic-title">Créer une tâche</h4>
      <button type="button" class="btn border-0 m-0 p-0 ms-auto" aria-label="Close" (click)="d('Cross click')">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="taskForm" (ngSubmit)="onSubmit()">
        <div class="d-flex flex-column mb-3">
          <label for="form_name">Nom</label>
          <input id="form_name" formControlName="title" type="text" required class="form-control">
        </div>

        <div class="d-flex flex-column mb-3">
          <label for="form_service">Service associé ( optionnel )</label>
          <select name="process" id="form_service" class="form-control" formControlName="service">
            <option value=""></option>
            <option value="{{s}}" *ngFor="let s of ServicesList">{{s}}</option>
          </select>
        </div>

        <div class="d-flex flex-column mb-3">
          <label for="form_language">Langue ( optionnel )</label>
          <select name="language" id="form_language" class="form-control" formControlName="language">
            <option value=""></option>
            <option value="{{l}}" *ngFor="let l of LanguageList">{{l}}</option>
          </select>
        </div>

        <div class="d-flex flex-column mb-3">
          <label for="form_priority">Priorité</label>
          <select name="priority" id="form_priority" class="form-control" formControlName="priority">
            <option value="{{p}}" *ngFor="let p of PriorityList">{{p}}</option>
          </select>
        </div>

        <div class="d-flex flex-column mb-3">
          <label for="form_description">Description</label>
          <textarea name="description" id="form_description" cols="30" rows="4" class="form-control" formControlName="content"></textarea>
        </div>

        <!-- @todo : mettre l'utilisateur actuel en first pour select par défaut -->
        <div class="d-flex flex-column">
          <label for="form_assign">Personne en charge</label>
          <select name="user_id" id="form_assign" class="form-control" formControlName="user_id">
            <option value="{{admin.id}}" *ngFor="let admin of administrators">{{admin.name}}</option>
          </select>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-lf-secondary text-primary w-25" (click)="c('Cross click')">Annuler
          </button>
          <button type="submit" class="btn btn-lf-primary w-25">Créer</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
